import type { Locale } from 'date-fns';
import { tv } from 'tailwind-variants';
import { PickerNavButton } from '@/shared/components/PickerNavButton';
import { MonthSelect } from './MonthSelect';
import { YearSelect } from './YearSelect';

type Props = {
  currentMonth: Date;
  locale: Locale;
  minDate: Date;
  maxDate: Date;
  canNavigate: { prev: boolean; next: boolean };
  onMonthSelect: (monthIndex: number) => void;
  onYearSelect: (year: number) => void;
  onMonthChange: (direction: 'prev' | 'next') => void;
};

const classes = tv({
  slots: {
    wrapper: 'flex items-center justify-between gap-[0.4rem]',
    selects: 'flex min-w-0 items-center gap-[0.4rem] sm:gap-[1.6rem]',
    navButtons: 'flex shrink-0 items-center gap-[0.4rem] sm:gap-[1.6rem]',
  },
});

export function CalendarHeader({
  currentMonth,
  locale,
  minDate,
  maxDate,
  canNavigate,
  onMonthSelect,
  onYearSelect,
  onMonthChange,
}: Props) {
  const c = classes();

  return (
    <div className={c.wrapper()}>
      <div className={c.selects()}>
        <MonthSelect
          currentMonth={currentMonth}
          locale={locale}
          minDate={minDate}
          maxDate={maxDate}
          onChange={onMonthSelect}
        />
        <YearSelect
          currentMonth={currentMonth}
          minDate={minDate}
          maxDate={maxDate}
          onChange={onYearSelect}
        />
      </div>
      <div className={c.navButtons()}>
        <PickerNavButton
          direction="prev"
          onClick={() => onMonthChange('prev')}
          isDisabled={!canNavigate.prev}
        />
        <PickerNavButton
          direction="next"
          onClick={() => onMonthChange('next')}
          isDisabled={!canNavigate.next}
        />
      </div>
    </div>
  );
}
